import useTranslate from '../../i18n/useTranslate'
import useCallApi from '../../utilities/axios'
import * as umServiceURL from './umServiceURL'

export type UplodeFileDocType = {
    uploadFileObj: {
        fileList: {
            replaceFileID: number | null
            fileID: number | null
            fileToken: string | null
            filename: string | null
            path: string
            date: string
        }[]
    }
}

export type FormType = {
    username: string
    password: string
    nameTH: string
    nameEN: string
    homeTelephone: string
    mobilePhone: string
    usergroupID: number
    title: lookUps
    position: lookUps
    irb: number
    isPhD: boolean
    cunet: boolean
    titleID?: string
    positionID?: string
    cunetID?: string
    positionOtherTH?: string
    positionOtherEN?: string
    titleOtherTH?: string
    titleOtherEN?: string
    signatureTH?: FileType[] | []
    signatureEN?: FileType[] | []
    isBothIrb: boolean
    documentInfo: UplodeFileDocType[]
}

export type Form = {
    username: string
    password: string
    nameTH: string
    nameEN: string
    homeTelephone: string
    mobilePhone: string
    usergroupID: number
    title: lookUps
    position: lookUps
    irb: number
    isPhD: boolean
    cunet: boolean
    titleID?: string
    positionID?: string
    signatureTH?: FileType[] | []
    signatureEN?: FileType[] | []
    isBothIrb: boolean
    documentInfo: {
        replaceFileID: number | null
        fileID: number | null
        fileToken: string | null
        filename: string | null
        path: string
        date: string
    }[]
    createdBy: number | null
}

export type FileType = {
    fileToken: string
    filename: string
    path: string
}

export type LanguageType = 'th' | 'en'

type lookUps = {
    id?: number | string | null
    name: {
        th?: string
        en?: string
    }
}

const useAddUsergroup = () => {
    const callApi = useCallApi()
    const t = useTranslate()

    const postOfficer = async (values: Form) => {
        const { data } = await callApi.axiosPost<any>({
            url: umServiceURL.postAddOfficer,
            params: { ...values, subject: t.get('UM.ACTIVATE.SUBJECT_MAIL') },
        })

        return data
    }
    return { postOfficer }
}

export default useAddUsergroup
